import _Reflect$construct from "@babel/runtime-corejs2/core-js/reflect/construct";
import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(_Reflect$construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import hoistStatics from 'hoist-non-react-statics';
import classNames from 'classnames';
import Step from '@alifd/next/lib/step';
import getDisplayName from '../../utils/getDisplayName';
import withWindConfig from '../../utils/withWindConfig';

/* eslint-disable react/static-property-placement */

/**
 * 提供size: 'small'选项，（目前仅对圆形step有效）
 */
var enhance = function enhance(WrappedComponent) {
  // eslint-disable-next-line react/prefer-stateless-function
  var EnhancedStep = /*#__PURE__*/function (_Component) {
    _inherits(EnhancedStep, _Component);

    var _super = _createSuper(EnhancedStep);

    function EnhancedStep() {
      _classCallCheck(this, EnhancedStep);

      return _super.apply(this, arguments);
    }

    _createClass(EnhancedStep, [{
      key: "render",
      value: function render() {
        var _this$props = this.props,
            size = _this$props.size,
            windConfig = _this$props.windConfig,
            className = _this$props.className,
            restProps = _objectWithoutProperties(_this$props, ["size", "windConfig", "className"]);

        var _restProps$shape = restProps.shape,
            shape = _restProps$shape === void 0 ? 'circle' : _restProps$shape,
            _restProps$direction = restProps.direction,
            direction = _restProps$direction === void 0 ? 'hoz' : _restProps$direction,
            _restProps$labelPlace = restProps.labelPlacement,
            labelPlacement = _restProps$labelPlace === void 0 ? '' : _restProps$labelPlace;
        var prefix = windConfig && windConfig.prefix ? windConfig.prefix : 'next-';
        var sizeClassName = "".concat(prefix, "enhanced-step-size-").concat(size);
        var dotClassName = ['circle', 'dot'].includes(shape) && direction === 'hoz' ? "".concat(prefix, "step-dot-circle-hoz").concat(labelPlacement ? '-placement' : '') : '';
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, restProps, {
          className: classNames(sizeClassName, className, dotClassName)
        }));
      }
    }]);

    return EnhancedStep;
  }(Component);

  _defineProperty(EnhancedStep, "displayName", "WindEnhanced(".concat(getDisplayName(WrappedComponent, 'Step'), ")"));

  _defineProperty(EnhancedStep, "propTypes", {
    size: PropTypes.oneOf(['medium', 'small']),
    className: PropTypes.string
  });

  _defineProperty(EnhancedStep, "defaultProps", {
    size: 'medium'
  });

  hoistStatics(EnhancedStep, Step);
  return EnhancedStep;
};

export default withWindConfig(enhance(Step));